"use client";

import { c as _c } from "react/compiler-runtime";
import { CSPostHogProvider } from "./providers";

// Client components still render their children on the server. Only analytics
// initialization belongs in an effect; it must not gate the application shell.
export default function PostHogProviderClient(t0) {
  const $ = _c(3);
  const {
    children,
    bootstrapData
  } = t0;
  let t1;
  if ($[0] !== bootstrapData || $[1] !== children) {
    t1 = <CSPostHogProvider bootstrapData={bootstrapData}>{children}</CSPostHogProvider>;
    $[0] = bootstrapData;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}